export default __webpack_public_path__ + "static/media/bkwp-logotype-l.f3c5b09f.svg";